import { isEmpty } from "lodash";
import SoftBadge from "modules/common/SoftBadge";
import moment from "moment";
import React from "react";

function OrderDetailsTable({ tableData }) {
  const dateKey = ["deliveryDate","placedDate"];
  return (
    <div>
      {!isEmpty(tableData)?<div>
        {tableData?.map((item, index) => {
          return (
            <div className="d-flex border rounded border-bottom-none border-secondary">
              <div className="border-end fw-bold p-3 fs-1 text-black"  style={{flex:"0.1"}}>{index+1}.</div>
              <div className="flex-1 p-3 d-flex flex-column gap-2">
                
                {Object.keys(item)
                  ?.filter((key) => key !== "productDetails") 
                  ?.map((key) => (
                    <div>
                    <div className="d-flex align-items-center" key={key}>
                      <span className="fw-bold flex-1 text-black">{key} </span>{" "}
                      {item[key]?dateKey.includes(key)?<SoftBadge bg="primary" className="flex-1">
                        <span style={{ fontSize: "12px" }}>{moment.utc(item[key]).utcOffset('+0530').format('YYYY-MM-DD HH:mm:ss')}</span>
                      </SoftBadge> :<SoftBadge bg="primary" className="flex-1">
                        <span style={{ fontSize: "12px" }}>{item[key]}</span>
                      </SoftBadge>:null}
                    </div>
                    <div className="border border-bottom"></div>
                    </div>
                  ))}
              </div>
              <div className="border "></div>
              <div className="flex-2">
                <div className="p-3">
                  <div className="d-flex border border-2 rounded bg-secondary  text-white">
                    <div className="flex-1 border-end fw-bold p-2">
                      Product Name
                    </div>
                    <div className="p-2 border-end fw-bold" style={{flex:"0.4"}}>Quantity</div>
                    <div className="flex-1 p-2 border-end fw-bold">variantId</div>
                    <div className="flex-1 p-2 border-end fw-bold">ProductId</div>
                  </div>
                  {item?.productDetails?.map((product, index) => {
                    const dataLength = item?.productDetails?.length - 1;
                    return (
                      <div
                        className={
                          index == dataLength
                            ? "d-flex border border-2 rounded text-secondary hover-bg-primary"
                            : "d-flex border border-bottom-0 border-2 text-secondary hover-bg-primary"
                        }
                      >
                        <div className="flex-1 p-2 border-end text-black">
                          <span className="text-black">
                            {product?.productName}
                          </span>
                        </div>
                        <div className="border-end p-2" style={{flex:"0.4"}}>
                          <span className="text-black" >{product?.qty}</span>
                        </div>
                        <div className="flex-1 border-end p-2">
                          <span className="text-black">{product?.variantId}</span>
                        </div>
                        <div className="flex-1 border-end p-2">
                          <span className="text-black">{product?.productId}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>:null}
    </div>
  );
}

export default OrderDetailsTable;
